(function(){
	var map, mapMarkers, circlesLayer, mapNode, markersDatas;
	var WP_theme = biensSearchAjax.WP_theme;
	var dossierDist = WP_theme + "/dist"; //Répertoire des images
	var formSearch, triRadio, avecCarteRadio;
	var listResultsSearch, nombreResultP;
	var preventBounce = false;

	//~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~
	// Récuparation de valeurs du formulaire nécessaires à la recherche
	var get_queries = function() {
		var postTypeInputs = formSearch['post_type'],
		villeInputs = formSearch['ville[]'],
		quartierInputs = formSearch['quartier[]'],
		typesBiensInputs = formSearch['typebien[]'],
		nbPiecesInputs = formSearch['nb_pieces[]'],
		budgetMaxInput = formSearch['budget_max'],
		equipInput = formSearch['equipements[]'],
		triInput = formSearch['tri'];

		var queries = {
			'post_type': [],
			'ville': [],
			'quartier': [],
			'typebien': [],
			'nb_pieces': [],
			'budget_max': '',
			'equipements': [],
			'tri': 'pertinence'
		};

		postTypeInputs.forEach(
			function(currentValue) {
				if (currentValue.checked) {
					queries.post_type = currentValue.value;
				}
			}
		);

		if (undefined !== typesBiensInputs) {
			typesBiensInputs.forEach(
				function(currentValue) {
					if (currentValue.checked) {
						queries.typebien.push(currentValue.value);
					}
				}
			);
		}

		if (undefined !== villeInputs) {
			if (NodeList.prototype.isPrototypeOf(villeInputs)) {
				villeInputs.forEach(
					function(currentValue) {
						if (currentValue.checked) {
							queries.ville.push(currentValue.value);
						}
					}
				);
			} else {
				if (villeInputs.checked) {
					queries.ville.push(villeInputs.value);
				}
			}
		}

		if (undefined !== quartierInputs) {
			if (NodeList.prototype.isPrototypeOf(quartierInputs)) {
				quartierInputs.forEach(
					function(currentValue) {
						if (currentValue.checked) {
							queries.quartier.push(currentValue.value);
						}
					}
				);
			} else {
				if (quartierInputs.checked) {
					queries.quartier.push(quartierInputs.value);
				}
			}
		}

		if (undefined !== nbPiecesInputs) {
			nbPiecesInputs.forEach(
				function(currentValue) {
					if (currentValue.checked) {
						queries.nb_pieces.push(currentValue.value);
					}
				}
			);
		}

		if (undefined !== budgetMaxInput && '' !== budgetMaxInput.value) {
			queries.budget_max = budgetMaxInput.value;
		}

		if (undefined !== equipInput) {
			if (NodeList.prototype.isPrototypeOf(equipInput)) {
				equipInput.forEach(
					function(currentValue) {
						if (currentValue.checked) {
							queries.equipements.push(currentValue.value);
						}
					}
				);
			} else {
				if (equipInput.checked) {
					queries.equipements.push(equipInput.value);
				}
			}
		}

		if (undefined !== triInput) {
			triInput.forEach(
				function(currentValue) {
					if (currentValue.checked) {
						queries.tri = currentValue.value;
					}
				}
			);
		}

		return queries;
	};

	var doMarker = function (markerData) {
		var precision = undefined === markerData.precision ? 2500 : markerData.precision;
		var details = '<a class="post-thumbnail" href="' + markerData.url + '" aria-hidden="true">\
		<p>' + markerData.title + '</p>\
		<figure><img src="' + markerData.thumbnail + '" alt="' + markerData.title + '" /></figure>\
		<p>Localision avec une précision de ' + markerData.precision + 'm.</p>\
		</a>';

		var marker = L.marker([markerData.lat, markerData.lng], {
			icon: L.icon({
				iconUrl: dossierDist + '/images/bulleK.d02262b2.png',
				iconSize: [32, 44],
				iconAnchor: [16, 44], // ancre sur top-center left par défaut
				tooltipAnchor: [15, 0],
				popupAnchor: [0, -44]
			}),
			zIndex: 999
		})
		.bindPopup(details)
		.bindTooltip('Précision de ' + precision + 'm.');
		// .addTo(mapMarkers);

		var circle = L.circle([markerData.lat, markerData.lng], {
			color: '#27326F',
			fillColor: '#CACEE1',
			fillOpacity: 0.5,
			radius: precision
		});

		marker.addEventListener("mouseover", function() {
			circlesLayer.clearLayers();
			circlesLayer.addLayer(circle);
			// circle.addTo(map);
		}, false);
		marker.addEventListener("mouseout", function() {
			circlesLayer.clearLayers();
			// circle.remove();
		}, false);

		mapMarkers.addLayer(marker);
	}

	//~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~
	// Ajax de recherche sur carte
	var ajaxSearchInMap = function () {
		var loader = '<div class="sk-fading-circle">\
			<div class="sk-circle1 sk-circle"></div>\
			<div class="sk-circle2 sk-circle"></div>\
			<div class="sk-circle3 sk-circle"></div>\
			<div class="sk-circle4 sk-circle"></div>\
			<div class="sk-circle5 sk-circle"></div>\
			<div class="sk-circle6 sk-circle"></div>\
			<div class="sk-circle7 sk-circle"></div>\
			<div class="sk-circle8 sk-circle"></div>\
			<div class="sk-circle9 sk-circle"></div>\
			<div class="sk-circle10 sk-circle"></div>\
			<div class="sk-circle11 sk-circle"></div>\
			<div class="sk-circle12 sk-circle"></div>\
		</div>';
		listResultsSearchJs.innerHTML = loader;
		preventBounce = true;
		var datas = get_queries();
		datas.bounds = map.getBounds();
		datas.center = map.getCenter();
		datas.avec_carte = 'ajax';
		// console.log(datas.bounds);
		var request = new XMLHttpRequest();
		request.open('POST', biensSearchAjax.ajaxurl + "?action=biens_search&security=" + biensSearchAjax.security + "&datas=" + JSON.stringify(datas), true);
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

		request.onload = function() {
			if (200 === this.status) {
				var json = JSON.parse(this.response)
				var markersDatas = json.markers;

				// map._panes.markerPane.remove();

				if ( json.count > 1 ) {
					nombreResultP.innerHTML = '<strong>' + json.count + ' biens</strong> correspondent à votre recherche';
				} else {
					nombreResultP.innerHTML = '<strong>' + json.count + ' bien</strong> correspond à votre recherche';
				}

				mapMarkers.clearLayers();

				markersDatas.forEach(doMarker);

				listResultsSearchJs.innerHTML = json.html;
			} else {
				console.log('fail | status : ' + this.status + ' | response : ' + this.response);
			}
		};

		request.onerror = function() {
			console.log('connection error');
		};

		request.send();
		preventBounce = false;
	};


	//~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~
	// Init de la Carte
	var initializeMap = function () {
		mapNode = document.querySelector("#maps");
		var infoDatas = JSON.parse(mapNode.getAttribute("data-maps"));

		var latLng = [];

		if (infoDatas.datas.length > 0) {
			markersDatas = infoDatas.datas;
			markersDatas.forEach(function(markerData){
				latLng.push([markerData.lat, markerData.lng]);
			});
		} else {
			markersDatas = [];
			latLng = infoDatas.defaultbounds;
		}

		var bounds = L.latLngBounds(latLng).pad(0.1); // TODO régler le padding
		L.Map.addInitHook("addHandler", "gestureHandling", leafletGestureHandling.GestureHandling);
		// L.Map.addInitHook("addHandler", "markercluster", Leaflet.markercluster);

		var mapOptions = {
			center: bounds.getCenter(),
			debounceMoveend: true,
			gestureHandling: true,
			gestureHandlingOptions: {
				duration: 1500
			}
		};

		if ( undefined === map ) {
			map = L.map("maps", mapOptions);
			// checkbox
			var command = L.control({position: 'topright'});
			command.onAdd = function () {
				var div = L.DomUtil.create('div', 'command');
				div.innerHTML = '<form class="leaflet-control-layers leaflet-control-layers-expanded"><label for="search_in_map"><input style="width:auto; vertical-align:middle;" id="search_in_map" type="checkbox" /> <span style="width:auto; vertical-align:middle;">Rechercher dans cette zone</span></label> </form>';
				return div;
			};
			command.addTo(map);
		}
		map.fitBounds(bounds);

		var osm = new L.TileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
		});
		map.addLayer(osm);

		L.control.scale().addTo(map);

		circlesLayer = L.layerGroup();
		map.addLayer(circlesLayer);

		// mapMarkers = new L.LayerGroup().addTo(map);
		mapMarkers = L.markerClusterGroup({
			chunkedLoading: true,
			iconCreateFunction: function() {
				return L.icon({
					iconUrl: dossierDist + '/images/bulleK.d02262b2.png',
					iconSize: [32, 44],
					iconAnchor: [16, 44], // ancre sur top-center left par défaut
					tooltipAnchor: [15, 0],
					popupAnchor: [0, -44]
				});
			}
		});

		var searchInMap = document.getElementById('search_in_map');
		searchInMap.addEventListener('click', function () {
			if (searchInMap.checked && !preventBounce) {
				listResultsSearch.classList.add('hidden');
				listResultsSearchJs.classList.remove('hidden');
				ajaxSearchInMap();
			} else {
				listResultsSearch.classList.remove('hidden');
				listResultsSearchJs.classList.add('hidden');
				refreshNonAjaxMap();
			}
		});

		map.addEventListener('zoomend', function () {
			if (searchInMap.checked && !preventBounce) {
				ajaxSearchInMap();
			}
		});
		map.addEventListener('moveend', function () {
			if (searchInMap.checked && !preventBounce) {
				ajaxSearchInMap();
			}
		});

		// mapMarkers.clearLayers();
		if ( markersDatas.length > 0 ) {
			markersDatas.forEach(doMarker);
		}

		map.addLayer(mapMarkers);
	}

	var refreshNonAjaxMap = function () {
		mapMarkers.clearLayers();
		if ( markersDatas.length > 0 ) {
			markersDatas.forEach(doMarker);
		}
		map.addLayer(mapMarkers);
	}

	//~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~
	// Sur DOM chargé
	document.addEventListener('DOMContentLoaded', function() {
		formSearch = document.forms.searchBandeau;
		triRadio = formSearch['tri'],
		avecCarteRadio = formSearch['avec_carte'],
		listResultsSearch = document.getElementById('list-results-search'),
		listResultsSearchJs = document.getElementById('list-results-search-js'),
		nombreResultP = document.getElementById('nombre-resultats');

		var triValue = document.querySelector('input[name="tri"]:checked').value,
		avecCarteValue = document.querySelector('input[name="avec_carte"]:checked').value;

		// soumission automatique du formulaire en cas de chagmenet de tri
		triRadio.forEach(
			function(currentValue) {
				currentValue.addEventListener('change', function() {
					if ( currentValue.checked && currentValue.value !== triValue ) {
						formSearch.submit();
					}
				});
			}
		);

		// soumission automatique du formulaire en cas de chagmenet de display carte / sans carte
		avecCarteRadio.forEach(
			function(currentValue) {
				currentValue.addEventListener('change', function() {
					if ( currentValue.checked && currentValue.value !== avecCarteValue ) {
						formSearch.submit();
					}
				});
			}
		);

		if ( 'true' === avecCarteValue ) {
			initializeMap();
		}
	});
})();
